module.exports = __webpack_public_path__ + "static/media/ExperimentalProducts.10c23504.jpg";